module.exports = __webpack_public_path__ + "img/img_intro_1_2.c95645bf.gif";